// ── spots ──────────────────────────────────────────────────────────────────
/** A spot's type (FR-SPT-01, decision 56). POSTGRES ENUM spot_category. */
export const SPOT_CATEGORY_OPTIONS = {
    park: { label: 'Park', icon: 'tree', learn: 'cruising-spots#parks-nature' },
    trail: { label: 'Trail', icon: 'path', learn: 'cruising-spots#parks-nature' },
    beach: { label: 'Beach', icon: 'umbrella', learn: 'cruising-spots#beaches' },
    restroom: {
        label: 'Restroom',
        icon: 'toilet',
        learn: 'cruising-spots#restrooms',
    },
    gym: { label: 'Gym', icon: 'dumbbell', learn: 'cruising-spots#locker-rooms' },
    locker_room: {
        label: 'Locker room',
        icon: 'lockers',
        hint: "A gym's or pool's locker room",
        learn: 'cruising-spots#locker-rooms',
    },
    sauna: {
        label: 'Sauna or bathhouse',
        icon: 'steam',
        learn: 'cruising-spots#spas',
    },
    bar: { label: 'Bar or club', icon: 'cocktail', learn: 'cruising-spots#bars' },
    store: { label: 'Adult store', icon: 'bag', learn: 'cruising-spots#arcades' },
    arcade: {
        label: 'Arcade',
        icon: 'screen',
        hint: 'Video booths, usually in an adult store',
        learn: 'cruising-spots#arcades',
    },
    rest_area: {
        label: 'Truck stop or rest area',
        icon: 'truck',
        learn: 'cruising-spots#rest-areas-parking-lots',
    },
    parking_lot: {
        label: 'Parking lot',
        icon: 'parking',
        learn: 'cruising-spots#rest-areas-parking-lots',
    },
    cruising_ground: {
        label: 'Cruising ground',
        icon: 'eye',
        hint: "An area known for cruising that isn't any one kind of place",
        learn: 'cruising-spots',
    },
    campground: {
        label: 'Campground',
        icon: 'tent',
        learn: 'cruising-spots#campgrounds',
    },
    hotel: { label: 'Hotel', icon: 'bed', learn: 'cruising-spots#hotels' },
    other: {
        label: 'Other',
        icon: 'marker',
        learn: 'cruising-spots#miscellaneous-places',
    },
};
//# sourceMappingURL=spots.js.map